module.exports = __webpack_public_path__ + "static/media/01.fff786c7.png";